export default "__VITE_ASSET__BNjZ13CA__"